import React from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";
import DevProfile from "/assets/images/yashprofile.jpg";

const PersonalStory = () => {
  const storyMilestones = [
    {
      id: 1,
      year: "2018",
      title: "The Spark",
      description: `It all started with a broken calculator app in college. Instead of asking for help, I spent three sleepless nights debugging JavaScript until I finally understood closures. That moment of clarity - when the code finally worked - was pure magic.`,
      icon: "Lightbulb",
      color: "text-conversion-accent",
    },
    {
      id: 2,
      year: "2019",
      title: "First Real Project",
      description: `Built a task management system for my university's student council. Seeing 500+ students actually use something I created was incredible. The feedback taught me that great code means nothing without great user experience.`,
      icon: "Rocket",
      color: "text-trust-builder",
    },
    {
      id: 3,
      year: "2021",
      title: "The Philosophy Shift",
      description: `After maintaining legacy code for months, I realized that writing code is easy - writing maintainable code is an art. This led me to embrace clean architecture, comprehensive testing, and documentation as core values.`,
      icon: "BookOpen",
      color: "text-cta",
    },
    {
      id: 4,
      year: "2023",
      title: "Teaching & Mentoring",
      description: `Started mentoring junior developers and contributing to open source. Teaching others solidified my belief that the best developers are those who lift others up while continuously learning themselves.`,
      icon: "Users",
      color: "text-warning",
    },
  ];

  return (
    <div className="space-y-12">
      {/* Hero Introduction */}
      <div className="text-center space-y-6">
        <div className="relative inline-block">
          <div className="w-32 h-32 mx-auto rounded-full overflow-hidden border-4 border-conversion-accent/20 shadow-elevation">
            <Image
              src={DevProfile}
              alt="Developer portrait"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-success rounded-full border-4 border-background flex items-center justify-center">
            <Icon name="Code2" size={16} color="white" />
          </div>
        </div>

        <div className="space-y-4">
          <h2 className="text-4xl font-bold text-foreground">
            Hi, I'm <span className="text-conversion-accent">Yash Pal</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            A passionate full-stack developer who believes that great software
            is built on the foundation of
            <span className="text-trust-builder font-semibold"> empathy</span>,
            <span className="text-conversion-accent font-semibold">
              {" "}
              curiosity
            </span>
            , and
            <span className="text-cta font-semibold"> craftsmanship</span>.
          </p>
        </div>
      </div>
      {/* <div className="space-y-8">
        <div className="text-center">
          <h3 className="text-2xl font-bold text-foreground mb-2">
            My Journey
          </h3>
          <p className="text-muted-foreground">
            The moments that shaped my development philosophy
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-conversion-accent via-trust-builder to-cta opacity-30" />

          <div className="space-y-12">
            {storyMilestones?.map((milestone, index) => (
              <div
                key={milestone?.id}
                className="relative flex items-start space-x-6 group"
              >
                <div
                  className={`relative z-10 w-16 h-16 rounded-full bg-card border-2 border-border flex items-center justify-center group-hover:border-conversion-accent/50 transition-smooth`}
                >
                  <Icon
                    name={milestone?.icon}
                    size={24}
                    className={milestone?.color}
                  />
                </div>

                <div className="flex-1 bg-card/50 backdrop-blur-sm border border-border rounded-xl p-6 group-hover:bg-card/80 group-hover:border-conversion-accent/20 transition-smooth">
                  <div className="flex items-center space-x-3 mb-3">
                    <span className="text-sm font-mono text-conversion-accent bg-conversion-accent/10 px-2 py-1 rounded">
                      {milestone?.year}
                    </span>
                    <h4 className="text-lg font-semibold text-foreground">
                      {milestone?.title}
                    </h4>
                  </div>
                  <p className="text-muted-foreground leading-relaxed">
                    {milestone?.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* Core Values */}
      {/* <div className="bg-card/30 backdrop-blur-sm border border-border rounded-xl p-8">
        <h3 className="text-xl font-bold text-foreground mb-6 text-center">
          What Drives Me
        </h3>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="text-center space-y-3">
            <div className="w-12 h-12 bg-conversion-accent/10 rounded-lg flex items-center justify-center mx-auto">
              <Icon name="Heart" size={24} className="text-conversion-accent" />
            </div>
            <h4 className="font-semibold text-foreground">User-Centric</h4>
            <p className="text-sm text-muted-foreground">
              Every line of code should serve a real human need
            </p>
          </div>

          <div className="text-center space-y-3">
            <div className="w-12 h-12 bg-trust-builder/10 rounded-lg flex items-center justify-center mx-auto">
              <Icon name="Zap" size={24} className="text-trust-builder" />
            </div>
            <h4 className="font-semibold text-foreground">Continuous Growth</h4>
            <p className="text-sm text-muted-foreground">
              Technology evolves fast, and so should we
            </p>
          </div>

          <div className="text-center space-y-3">
            <div className="w-12 h-12 bg-cta/10 rounded-lg flex items-center justify-center mx-auto">
              <Icon name="Shield" size={24} className="text-cta" />
            </div>
            <h4 className="font-semibold text-foreground">Quality First</h4>
            <p className="text-sm text-muted-foreground">
              Sustainable code that stands the test of time
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default PersonalStory;
